import './SearchBox.scss'
import SearchBoxProps from "./SearchBoxProps";
import { IoIosSearch as SearchIcon } from "react-icons/io";
import { useState } from 'react';

const SearchBox = (props: SearchBoxProps) => {

  const [loader, setLoader] = useState(false)   


    const { placeholder, classes, changeHandler, value, onEnter , iconColor } = props;

    const _handleKeyDown = (e: any) => {
        setLoader(!loader)
        if (e.key === 'Enter' && onEnter) {
            onEnter(e)
        }
    }

    return (
        <div className="search-box">
            <div className="icon-wrap">
                <SearchIcon className={`icon ${iconColor}`} />
            </div>
            <input
                className={`input ${classes}`}
                type="text"
                placeholder={placeholder}
                value={value ? value : ''}
                onKeyDown={(e) => _handleKeyDown(e)}
                onChange={changeHandler}
            />
        </div>
    )
}

export default SearchBox;